import { setShowValuationCompletionModal } from '../../../State/showValuationCompletionModal';

export default () => async (dispatch) => {

  dispatch(setShowValuationCompletionModal(true));
  
}